module.exports = __webpack_public_path__ + "img/honor21.59edb349.png";